import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useSelector,useDispatch } from 'react-redux'
import { useDebounce, useUpdateEffect } from '../../../hooks'
import { restrictDecimal,blockDecimal } from '../../../Helper'
import PopUpIcon from '../../../commonComponents/formComponents/PopUpIcon'
import {addItemsTabWarnings,deleteItemsTabWarnings} from "../../actions/errorValidationActions";
import { validation } from '../../util/cdsFieldPatterns';



const MerchForm4 = ({
  isFormDisabled, 
  merchandiseId,
  updateData,
  saveData,
  saveInvoiceSummary, 
  saveMassRelatedField,
  invoiceId,
  lineNumber,
  isImportShipment,
  invoiceItemIndex,
  fieldPattern,
  validateError,
}) =>{
 
  const packageTypes=useSelector((state) => state.DropDownValues.packageTypes)
  const packageCount=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.packageCount)
  const packageType=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.packageType)
  const itemCount=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.itemCount)
  const itemValue=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.itemValue)
  const itemPrice=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.itemPrice)
  const convertedValue=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.convertedValue)
  const statisticalValue=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.statisticalValue)

  const packageCountErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_packageCount`]) 
  const packageTypeErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_packageType`]) 
  const statisticalValueErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_statisticalValue`]) 


 
  const debouncedValue = useDebounce(itemPrice+itemCount, 300)
  useUpdateEffect(()=>{
    const itemValue=((itemPrice || 0) * (itemCount || 0))?.toFixed(2)
     updateData({itemValue})
     saveInvoiceSummary({itemValue})
  },[debouncedValue])
  const { declarationCat = '' } = useSelector((state) => state.Shipment) || []
  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'itemsTab'),
    [declarationCat]
  )

  const dispatch=useDispatch()


  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }

  return (
    <Grid.Row>
      <Grid.Column width={2} className='divFormFeild b-rw-0 '>
        <InputField
          isLabel={false}
          id={`packageCount-${invoiceId}-${merchandiseId}`}
          type='number'
          boxNumber="6/10"
          label='Number of packages'
          value={packageCount}
          errors={isImportShipment ? 
            getValidationError("packageCount",packageCount) :
            packageCountErr && packageCountErr?.msg
          }
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          onChange={(value) =>updateData({packageCount:value})}
          onBlur={(value)=>{saveMassRelatedField({packageCount: packageCount || " " })
          const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_packageCount`
          validateError(
            { [key]: '' },
            { [key]: value },
            { [key]: fieldPattern({declarationCat}).items?.lineItem(invoiceItemIndex + 1, lineNumber)?.packageCount }
          )
          let err = getValidationError('packageCount', packageCount, 'itemsTab')
                          err.length
                            ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `packageCount-${merchandiseId}`)
                            : deleteErrors('itemsTab', '', `packageCount-${merchandiseId}`)
        }}
        />
      </Grid.Column>
      <Grid.Column width={3} className='b-rw-0 divFormFeild'>
        <DropDown
          id={`packageType-${invoiceId}-${merchandiseId}`}
          label='Type of packages'
          boxNumber="6/9"
          disabled={isFormDisabled}
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          isLabel={true}
          mandatory={false}
          data={packageTypes}
          value={packageType}
          errors={isImportShipment ?
            getValidationError("packageType",packageType,true) :
            packageTypeErr && packageTypeErr?.msg
          }
          clearable
          onChange={(value) =>{
            updateData({packageType:value?.trim()})
            saveData({packageType:value})
            const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_packageType`
            validateError(
              { [key]: '' },
              { [key]: value },
              { [key]: fieldPattern({declarationCat}).items?.lineItem(invoiceItemIndex + 1, lineNumber)?.packageType }
            )

            let err = getValidationError('packageType', value, 'itemsTab',true)
                          err.length
                            ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `packageType-${merchandiseId}`)
                            : deleteErrors('itemsTab', '', `packageType-${merchandiseId}`)
          }
        }
        />
       
      </Grid.Column>

      <Grid.Column width={2} className='divFormFeild b-rw-0'>
        <InputField
          isLabel={false}
          id={`itemCount-${invoiceId}-${merchandiseId}`}
          type='number'
          label='Item Count'
          value={itemCount}
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          onKeyDown={blockDecimal}
          onChange={(value) =>updateData({itemCount:value})}
          onBlur={()=>saveData({itemCount:itemCount || " "})}
        />
      </Grid.Column>

      <Grid.Column width={3} className='divFormFeild b-rw-0'>
      <InputField
          isLabel={false}
          id={`itemValue-${invoiceId}-${merchandiseId}`}
          type='number'
          label='Item Value'
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          value={itemPrice}
          onChange={(value) =>{
            if(restrictDecimal(value))
            updateData({itemPrice:value})}
          }
          onBlur={()=>saveData({itemPrice:itemPrice || " "})}
        />
        
      </Grid.Column>
      {isImportShipment && 
      <Grid.Column width={3} className='divFormFeild b-rw-0'>
      <InputField
          isLabel={false}
          id={`calculatedValue-${invoiceId}-${merchandiseId}`}
          type='number'
          label='Calculated Value'
          value={itemValue}
          className='field-bg'
          clearInput={false}
          disabled={true}
          onChange={(value) =>updateData({itemValue:value})}
          onBlur={()=>saveData({itemValue:itemValue || " "})}
         
        />
      </Grid.Column>
       }
      <Grid.Column width={3} className={ isImportShipment ? 'divFormFeild' : 'divFormFeild b-rw-0'}>
        <InputField
          isLabel={false}
          id={`itemPrice-${invoiceId}-${merchandiseId}`}
          type='number'
          boxNumber="4/14"
          labelIcon = {<PopUpIcon icon='info circle' popupText={"Item Price Converted Value"} />}
          label='ITEM PRICE'
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          value={convertedValue}
          onChange={(value) =>updateData({convertedValue:value})}
          onBlur={()=>saveData({convertedValue:convertedValue || " "})}
        />
      </Grid.Column>
      {
        !isImportShipment &&  <Grid.Column width={3} className='divFormFeild'>
       <InputField
          isLabel={false}
          id={`statisticalValue-${invoiceId}-${merchandiseId}`}
          type='number'
          label='STATISTICAL VALUE'
          boxNumber="8/6"
          mandatory={false}
          value={statisticalValue}
          errors={!isImportShipment && statisticalValueErr && statisticalValueErr?.msg}
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          onChange={(value) =>updateData({statisticalValue:value})}
          onBlur={()=>{
            saveData({statisticalValue:statisticalValue || " "})
            const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_statisticalValue`
            validateError(
              { [key]: '' },
              { [key]: value },
              { [key]: fieldPattern().items?.lineItem(invoiceItemIndex + 1, lineNumber)?.statisticalValue }
            )
          }}
        />
        </Grid.Column>
      }
    </Grid.Row>
  )
}

export default React.memo(MerchForm4)
